/** Localized text bundle for the mating module. */
export const matingTranslations = {
    CS: {
        mating: {
            matingPlanH: 'Připařovací plán ‐ H',
            matingPlan: 'Připařovací plán ‐ H',
            cowGroupSelection: 'Výběr skupiny plemenic',
            bullGroupSelection: 'Výběr skupiny býků',
            loadingMatingPlan: 'Načítání připařovacího plánu…',
            calcParamsSelection: 'Výběr parametrů výpočtu',
            result: 'Výsledek',
            resetAllSettings: 'Obnovení všech nastavení',
            bullSelectorH: 'Bullselector pro plemeno H',
            bullSelectorC: 'Bullselector pro plemeno C',
            loadingBullSelector: 'Načítání Bullselectoru…',
            lineRegistry: 'Linie-Registr',
            name: 'Jméno',
            organization: 'Organizace',
            earTagShort: 'UZ',
            actionRewritesAnimalList: 'Tato akce přepíše aktuální seznam zvířat.',
            formIsInvalid: 'Formulář je nevalidní.',
            filter: 'Filtrovat',
            addBulls: 'Přidat býky',
            addBullsFromFile: 'Přidat býky ze souboru',
            activeWithAtLeastOneBullList: 'Funkce je aktivní při alespoň jednom uloženém seznamu býků.',
            addBullsFromList: 'Přidat býky ze seznamu',
            activeWithAtLeastOneAddedBull: 'Funkce je aktivní při alespoň jednom přidaném býkovi do seznamu.',
            saveBullList: 'Uložit seznam býků',
            deleteBulls: 'Smazat býky',
            activeWithAtLeastOneCriteriaList: 'Funkce je aktivní při alespoň jednom uloženém seznamu kritérií.',
            loadCriteriaFromList: 'Načíst parametry ze seznamu',
            manageSavedLists: 'Spravovat uložené seznamy',
            chooseAllOrganizations: 'Vybrat všechny organizace',
            breeder: 'Chovatel',
            farms: 'Hospodářství',
            addCows: 'Přidat plemenice',
            addCowsFromFile: 'Přidat plemenice ze souboru',
            activeWithAtLeastOneCowList: 'Funkce je aktivní při alespoň jednom uloženém seznamu plemenic.',
            addCowsFromList: 'Přidat plemenice ze seznamu',
            activeWithAtLeastOneAddedCow: 'Funkce je aktivní při alespoň jedné přidané plemenici do seznamu.',
            saveCowsList: 'Uložit seznam plemenic',
            deleteCows: 'Smazat plemenice',
            numberOfAnimals: '{{number}} ks',
            fillEarTag: 'Zadejte ušní číslo',
            fillLineAndRegister: 'Zadejte linie a registr',
            chooseAnimalList: 'Vyberte seznam zvířat',
            animalList: 'Seznam zvířat',
            addingAnimalsFromFile: 'Probíhá proces vkládání jedinců ze souboru do aplikace.',
            term: 'Název',
            enterCriteriaListName: 'Zadejte jméno seznamu kritérií',
            confirmListName: 'Potvrďte jméno seznamu',
            listAlreadyExists: 'Seznam se zvoleným názvem již existuje. Přejete si přepsat uložený seznam?',
            atLeastOneAnimal: 'Seznam zvířat musí obsahovat minimálně jedno zvíře.',
            saveBreeders: 'Uložení plemenic',
            saveBulls: 'Uložení býků',
            criteriaList: 'Seznam parametrů',
            defaultList: 'základní seznam',
            chooseCriteriaList: 'Vyberte seznam parametrů výběru',
            cantSaveParams: 'Uložení seznamu parametrů není možné v důsledku nevalidních dat, která byla zadána.',
            paramsSubmitTooltip: 'Jméno nemůže být prázdné.',
            noSavedLists: 'Nebyly uloženy žádné seznamy.',
            managementOfSavedLists: 'Správa uložených seznamů',
            areYouSure: 'Jste si jisti, že chcete opravdu smazat tento seznam?',
            listAlreadyExistsWarning: 'Uložením nového seznamu přepíšete původní.',
            nameAlreadyExistsInTableWarning: 'Uložením nového seznamu přepíšete existující nastavení tabulky.',
            enterFileName: 'Zadejte název souboru.',
            maxFileNameLength: 'Délka názvu souboru je maximálně 100 znaků.',
            savingMatingPlan: 'Uložení připařovacího plánu',
            mustBeFilledIn: 'Musí být vyplněné',
            wrongCoefficientFormat: 'Koeficient má nesprávný formát',
            inbreedingCoefficientOutsideAllowedRange: 'Koeficient je mimo povolený rozsah',
            weightOutsideAllowedRange: 'Váha je mimo povolený rozsah',
            idealWeightOutsideAllowedRange: 'Váha znaku je mimo povolený rozsah',
            code: 'Kód',
            loadingCalculationCriteria: 'Načítání parametrů výpočtu…',
            formInvalid: 'Formulář není validní',
            noBullsOrCowsSelected: 'Nemáte vybrány plemenice nebo býky',
            scoreIsBeingCalculated: 'Probíhá výpočet skóre',
            productionSignsWeight: 'Váhy produkčních znaků',
            medicalSignsWeight: 'Váhy zdravotních znaků',
            functionalSignsWeight: 'Váhy funkčních znaků',
            signWeight: 'Váha znaku',
            shareOfSignsInTotalScore: 'Podíl skupin znaků na celkovém skóre',
            calculateScore: 'Vypočíst skóre',
            noListAvailable: 'Není k dispozici žádný seznam parametrů',
            saveCriteriaList: 'Uložit seznam parametrů',
            inPoints: 'V bodech',
            upToFourExterior: 'Doporučujeme vybrat maximálně čtyři znaky exteriéru.',
            minimumFemaleAgeInMonthsTooltip:
                'Minimální věk plemenic, pro které se počítá koeficient příbuznosti je {{number}} měsíce/ů!',
            mustBeWholeNumber: 'Hodnota musí být celé číslo.',
            resetPreferencesRecalculation: 'Resetovat přepočet preferencí',
            recalculateAccordingToSelectedPreferences: 'Přepočíst dle zvolených preferencí',
            saveResultToFile: 'Uložit výsledek do souboru',
            noPercentagesEntered: 'Nemáte vyplněna žádná procenta',
            sumOfPercentagesDoesNotAddUp: 'Součet procent není roven 100',
            lesserThan: 'Menší než',
            greaterThan: 'Větší než',
            total: 'Celkem',
            bull: 'Býk {{number}}',
            frequency: 'Četnost',
            share: '% podíl',
            score: 'Skóre',
            bullInbreeding: 'Příb.',
            lineRegistryShort: 'LIN-REG',
            saveAnimalList: 'Uložení seznamu zvířat',
            listOfStallionsSavedSuccessfully: 'Seznam plemenic úspěšně uložen',
            loadingBullList: 'Načtení seznamu býků',
            noBullsMatchTheFilter: 'Filtru neodpovídají žádní býci.',
            renameAnimalList: 'Přejmenování seznamu zvířat',
            deleteAnimals: 'Smazání zvířat',
            animalsDeleted: 'Zvířata byla úspěšně smazána.',
            resetComplete: 'Obnovení dokončeno.',
            loadCowList: 'Načtení seznamu krav',
            noStudsMatchTheFilter: 'Filtru neodpovídají žádné plemenice.',
            loadCriteriaList: 'Načtení parametrů výběru',
            criteriaLoaded: 'Parametry byly úspěšně načteny',
            renameCriteriaList: 'Přejmenování seznamu kritérií',
            criteriaListRenamed: 'Seznam kritérií úspěšně přejmenován',
            removeAnimal: 'Odebrání zířete',
            animalRemoved: 'Zvíře bylo odebráno.',
            deleteAnimalList: 'Odstranění seznamu zvířat',
            animalListDeleted: 'Seznam zvířat byl úspěšně smazán',
            addAnimalsFromFile: 'Přidání zvířat ze souboru',
            loadFarmsForBreeder: 'Načtení hospodářství pro chovatele',
            createCriteriaList: 'Vytvoření seznamu kritérií',
            criteriaListCreated: 'Seznam kritérií úspěšně vytvořen',
            loadCriteriaLists: 'Načtení seznamů kritérií',
            loadBullOrganizations: 'Načtení organizací býků',
            deleteCriteriaList: 'Odstranění seznamu kritérií',
            criteriaListDeleted: 'Seznam kritérií byl úspěšně smazán',
            addAnimals: 'Přidání zvířat',
            animalsFiltering: 'Filtrování zvířat',
            loadMatingScore: 'Načtení výsledků hodnocení',
            inbreedingExceeded: 'Z důvodu překročení maximální hodnoty příbuznosti se mating skóre nepočítalo pro',
            pairs: 'párů',
            loadAnimalsList: 'Načtení seznamů zvířat',
            animalsAdded: 'Zvířata byla úspěšně přidána.',
            addAnimalsFromDb: 'Přidání zvířat z databáze',
            animalsAddedFromDb: 'Zvířata byla úspěšně přidána z databáze.',
            criteriaListSaved: 'Seznam kritérií úspěšně uložen',
            createAnimalList: 'Vytvoření seznamu zvířat',
            animalListCreated: 'Seznam zvířat úspěšně vytvořen',
            loadBreederList: 'Načtení seznamu chovatelů',
            loadAccordionDefinitions: 'Načtení definice akordeonů',
            loadCriteriaDefinitionsFor: 'Načtení definice kritérií pro',
            loadSessionFilters: 'Načtení uložených filtrů',
            loadScoringParams: 'Načtení parametrů výpočtu',
            animalListRenamed: 'Seznam zvířat úspěšně přejmenován',
        },
    },
    EN: {
        mating: {
            matingPlanH: 'Mating plan ‐ H',
            matingPlan: 'Mating plan ‐ H',
            cowGroupSelection: 'Cow group selection',
            bullGroupSelection: 'Bull group selection',
            loadingMatingPlan: 'Loading mating plan...',
            calcParamsSelection: 'Calculation parameters selection',
            result: 'Result',
            resetAllSettings: 'Reset all settings',
            bullSelectorH: 'Bullselector - H',
            bullSelectorC: 'Bullselector - C',
            loadingBullSelector: 'Loading Bullselector...',
            lineRegistry: 'Line-Registry',
            name: 'Name',
            organization: 'Organization',
            earTagShort: 'ET',
            actionRewritesAnimalList: 'This action rewrites the current animal list.',
            formIsInvalid: 'Form is invalid.',
            filter: 'Filter',
            addBulls: 'Add bulls',
            addBullsFromFile: 'Add bulls from a file',
            activeWithAtLeastOneBullList: 'Function is active when at least one bull list is added.',
            addBullsFromList: 'Add bulls from a list',
            activeWithAtLeastOneAddedBull: 'Function is active when at least one bull is added to the list.',
            saveBullList: 'Save bull list',
            deleteBulls: 'Delete bulls',
            activeWithAtLeastOneCriteriaList: 'Function is active when at least one criteria list is added.',
            loadCriteriaFromList: 'Load criteria from list',
            manageSavedLists: 'Manage saved lists',
            chooseAllOrganizations: 'Choose all organizations',
            breeder: 'Breeder',
            farms: 'Farms',
            addCows: 'Add cows',
            addCowsFromFile: 'Add cows from a file',
            activeWithAtLeastOneCowList: 'Function is active when at least one cow list is added.',
            addCowsFromList: 'Add cows from a list',
            activeWithAtLeastOneAddedCow: 'Function is active when at least one cow is added to the list.',
            saveCowsList: 'Save cows list',
            deleteCows: 'Delete cows',
            numberOfAnimals: '{{number}} pcs',
            fillEarTag: 'Enter ear tag',
            fillLineAndRegister: 'Enter line-registry',
            chooseAnimalList: 'Choose animal list',
            animalList: 'Animal list',
            addingAnimalsFromFile: 'The process of adding individuals from a file to the application is in progress.',
            term: 'Name',
            enterCriteriaListName: 'Enter criteria list name',
            confirmListName: 'Confirm list name',
            listAlreadyExists: 'A list with the name you entered already exists. Do you wish to overwrite the saved list?',
            atLeastOneAnimal: 'Animal list has to contain at least one animal.',
            saveBreeders: 'Save breeders',
            saveBulls: 'Save bulls',
            criteriaList: 'Criteria list',
            defaultList: 'default list',
            chooseCriteriaList: 'Choose criteria list',
            cantSaveParams: 'The saving of the parameter list is not possible due to invalid data that was entered.',
            paramsSubmitTooltip: 'Name cannot be empty.',
            noSavedLists: 'No lists were saved.',
            managementOfSavedLists: 'Management of saved lists',
            areYouSure: 'Are you sure you want to delete this list?',
            listAlreadyExistsWarning: 'Saving the new list will overwrite the existing one.',
            nameAlreadyExistsInTableWarning: 'Saving the new list will overwrite the existing table setting name.',
            enterFileName: 'Enter file name.',
            maxFileNameLength: 'The maximum length for the file name is 100 characters.',
            savingMatingPlan: 'Saving mating plan',
            mustBeFilledIn: 'Must be filled in',
            wrongCoefficientFormat: 'The coefficient is formatted incorrectly.',
            inbreedingCoefficientOutsideAllowedRange: 'The coefficient is outside of allowed range',
            weightOutsideAllowedRange: 'Weight is outside of allowed range',
            idealWeightOutsideAllowedRange: 'Ideal weight is outside of allowed range',
            code: 'Code',
            loadingCalculationCriteria: 'Loading calculation criteria...',
            formInvalid: 'Form is invalid',
            noBullsOrCowsSelected: 'You have no bulls or cows selected',
            scoreIsBeingCalculated: 'Score is being calculated',
            productionSignsWeight: 'Weights of production signs',
            medicalSignsWeight: 'Weights of medical signs',
            functionalSignsWeight: 'Weights of functional signs',
            signWeight: 'Sign weight',
            shareOfSignsInTotalScore: 'The share of groups of characters in the total score',
            calculateScore: 'Calculate score',
            noListAvailable: 'No criteria list available',
            saveCriteriaList: 'Save criteria list',
            inPoints: 'In points',
            upToFourExterior: 'We recommend choosing a maximum of four exterior traits.',
            minimumFemaleAgeInMonthsTooltip:
                'Minimum cow age for which the inbreeding coefficient is calculated is {{number}} months!',
            mustBeWholeNumber: 'The value must be a whole number.',
            resetPreferencesRecalculation: 'Reset preferences recalculation',
            recalculateAccordingToSelectedPreferences: 'Recalculate according to selected preferences',
            saveResultToFile: 'Save result to file',
            noPercentagesEntered: 'You have no percentages entered',
            sumOfPercentagesDoesNotAddUp: 'The sum of the percentages is not equal to 100',
            lesserThan: 'Lesser than',
            greaterThan: 'Greater than',
            total: 'Total',
            bull: 'Bull {{number}}',
            frequency: 'Frequency',
            share: '% share',
            score: 'Score',
            bullInbreeding: 'Inbr.',
            lineRegistryShort: 'LIN-REG',
            saveAnimalList: 'Save animal list',
            listOfStallionsSavedSuccessfully: 'List of stallions saved successfully',
            loadingBullList: 'Load bull list',
            noBullsMatchTheFilter: 'No bulls match the filter.',
            renameAnimalList: 'Rename animal list',
            deleteAnimals: 'Delete animals',
            animalsDeleted: 'Animals were deleted successfully.',
            resetComplete: 'Reset complete.',
            loadCowList: 'Load cow list',
            noStudsMatchTheFilter: 'No studs match the filter.',
            loadCriteriaList: 'Load criteria list',
            criteriaLoaded: 'Criteria were successfully loaded',
            renameCriteriaList: 'Rename criteria list',
            criteriaListRenamed: 'Criteria list was renamed successfully',
            removeAnimal: 'Remove animal',
            animalRemoved: 'Animal was removed.',
            deleteAnimalList: 'Delete animal list',
            animalListDeleted: 'Animal list was successfully deleted',
            addAnimalsFromFile: 'Add animals from file',
            loadFarmsForBreeder: 'Load farms for breeder',
            createCriteriaList: 'Create criteria list',
            criteriaListCreated: 'Criteria list was created successfully',
            loadCriteriaLists: 'Load criteria list',
            loadBullOrganizations: 'Load bull organizations',
            deleteCriteriaList: 'Delete criteria list',
            criteriaListDeleted: 'Criteria list was successfully deleted',
            addAnimals: 'Add animals',
            animalsFiltering: 'Animals filtering',
            loadMatingScore: 'Load mating score',
            inbreedingExceeded:
                'Due to exceeding the maximum value of relatedness, the mating score was not calculated for',
            pairs: 'pairs',
            loadAnimalsList: 'Load animals list',
            animalsAdded: 'Animals were successfully added.',
            addAnimalsFromDb: 'Add animals from DB',
            animalsAddedFromDb: 'Animals were successfully added from the database.',
            criteriaListSaved: 'Criteria list was saved successfully',
            createAnimalList: 'Create animal list',
            animalListCreated: 'Animals list was created successfully',
            loadBreederList: 'Load breeder list',
            loadAccordionDefinitions: 'Load accordion definitions',
            loadCriteriaDefinitionsFor: 'Load criteria definitions for',
            loadSessionFilters: 'Load saved filters',
            loadScoringParams: 'Load scoring parameters',
            animalListRenamed: 'Animal list renamed successfully',
        },
    },
};
